import matter from 'gray-matter';
import type { SavedMessage } from '../services/api';
import { cleanMetadata } from './metadataHelpers';

interface SavedMessagePayload {
  title?: string;
  content: string;
  notes?: string;
  tags?: string[];
  citations?: Record<string, any> | null;
  selected_documents?: string[];
  created_at?: string;
  updated_at?: string;
  usage_stats?: Record<string, any> | null;
  rag_stats?: Record<string, any> | null;
}

const _buildSavedMessageMetadata = (data: SavedMessagePayload): Record<string, any> => {
  return {
    title: data.title || 'Mensaje guardado',
    notes: data.notes,
    tags: data.tags ?? [],
    citations: data.citations,
    selected_documents: data.selected_documents ?? [],
    usage_stats: data.usage_stats,
    rag_stats: data.rag_stats,
    created_at: data.created_at,
    updated_at: data.updated_at,
  };
};


export const serializeSavedMessage = (data: SavedMessagePayload) => {
  const metadata = _buildSavedMessageMetadata(data);
  cleanMetadata(metadata);

  const content = data.content?.trim() || '*Sin contenido*';

  return {
    markdown: matter.stringify(content, metadata),
    metadata,
  };
};

export const parseSavedMessageMarkdown = (markdown?: string) => {
  try {
    return matter(markdown ?? '');
  } catch (error) {
    console.error('Error parsing saved message markdown:', error);
    return matter('');
  }
};












